/** PURE_IMPORTS_START .._operators_repeatWhen PURE_IMPORTS_END */
import { repeatWhen as higherOrder } from '../operators/repeatWhen';
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
export function repeatWhen(notifier) {
    return higherOrder(notifier)(this);
}
//# sourceMappingURL=repeatWhen.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/repeatWhen.js
// module id = 846
// module chunks = 0